import { Box } from '@mui/material'
import { ICowsList } from 'models/ICattlesData'
import { ReactNode } from 'react'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeaderSecondary } from 'ui/typography/TypographyHeaderSecondary'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import {
	DateDaysValue,
	NO_LAMENESS_DATA,
	formatDateWithDays,
	formatLamenessValue,
	getMainInfoLeftFields,
} from '../utils/mainInfoFields'

type MainInfoProps = {
	cowInfo: ICowsList
}

const InfoRow = ({ label, value }: { label: string; value: ReactNode }) => (
	<Box
		display='flex'
		flexDirection='row'
		alignItems='flex-start'
		gap='8px'
		minWidth={0}
	>
		<TypographySecondary14 sx={{ flexShrink: 0 }}>
			{label}
		</TypographySecondary14>
		<TypographyPrimary sx={{ minWidth: 0, wordBreak: 'break-word' }}>
			{value}
		</TypographyPrimary>
	</Box>
)

const SlashDaysText = ({ primary, days, dayWord }: DateDaysValue) => (
	<>
		{primary}
		<span style={{ color: COLORS.secondary }}>
			{' / '}
			{days} {dayWord}
		</span>
	</>
)

const MainInfoSection = ({ cowInfo }: MainInfoProps) => {
	const leftFields = getMainInfoLeftFields(cowInfo)
	const lamenessValue = formatLamenessValue(
		cowInfo.limpness,
		cowInfo.limpness_start_dt,
	)
	const treatmentValue = formatDateWithDays(cowInfo.first_examination_date)
	const trimValue = formatDateWithDays(cowInfo.trim_last_dt)

	return (
		<CardStandart sx={{ padding: '24px' }}>
			<Box
				display='flex'
				flexDirection='row'
				width='100%'
				alignItems='flex-start'
				gap='40px'
			>
				<Box width='150px' flexShrink={0}>
					<TypographyHeaderSecondary>
						Основная
						<br />
						информация
					</TypographyHeaderSecondary>
				</Box>
				<Box
					display='flex'
					flexDirection='column'
					width='40%'
					minWidth={0}
					gap='16px'
				>
					{leftFields.map(field => (
						<InfoRow
							key={field.label}
							label={field.label}
							value={field.value}
						/>
					))}
				</Box>
				<Box
					display='flex'
					flexDirection='column'
					width='40%'
					minWidth={0}
					gap='16px'
				>
					<InfoRow
						label='Балл хромоты:'
						value={
							lamenessValue ? (
								<SlashDaysText {...lamenessValue} />
							) : (
								NO_LAMENESS_DATA
							)
						}
					/>
					<InfoRow
						label='Начало лечения:'
						value={<SlashDaysText {...treatmentValue} />}
					/>
					<InfoRow
						label='Последняя обрезка:'
						value={<SlashDaysText {...trimValue} />}
					/>
				</Box>
			</Box>
		</CardStandart>
	)
}

export default MainInfoSection
